import Hero from '../components/landing/Hero';
import ProblemSection from '../components/landing/ProblemSection';
import PrivacyLayerSection from '../components/landing/PrivacyLayerSection';
import FeaturesSection from '../components/landing/FeaturesSection';
import WhoItsForSection from '../components/landing/WhoItsForSection';
import TeamsSection from '../components/landing/TeamsSection';
import HowItWorksSection from '../components/landing/HowItWorksSection';
import PricingSection from '../components/landing/PricingSection';
import SecuritySection from '../components/landing/SecuritySection';
import ApproachSection from '../components/landing/ApproachSection';
import FAQSection from '../components/landing/FAQSection';
import CTASection from '../components/landing/CTASection';

export default function LandingPage() {
  return (
    <>
      <Hero />
      <ProblemSection />
      <PrivacyLayerSection />
      <FeaturesSection />
      <WhoItsForSection />
      <TeamsSection />
      <HowItWorksSection />
      <PricingSection />
      <SecuritySection />
      <ApproachSection />
      <FAQSection />
      <CTASection />
    </>
  );
}
